import React, { useState } from 'react';
import axios from 'axios';
import { theme, cardStyle, btnStyle, inputStyle } from '../theme';

const LiteratureSearchPage = ({ API_BASE }) => {
  const [q, setQ] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);

  const search = async () => {
    if (!q.trim()) return;
    setLoading(true);
    try {
      const { data } = await axios.get(`${API_BASE}/literature/search`, { params: { q, max: 15 } });
      setResults(data.results || []);
      setTotal(data.total || 0);
    } catch (e) { alert('Search failed: ' + (e.response?.data?.error || e.message)); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <div style={{ ...cardStyle, marginBottom: 14 }}>
        <h2 style={{ margin: 0, color: theme.navy }}>📚 Medical Literature Search</h2>
        <p style={{ margin: '6px 0 12px', fontSize: 13, color: theme.textMuted }}>
          Evidence-based lookup via PubMed (NCBI). Results biased to dental/oral literature.
        </p>
        <div style={{ display: 'flex', gap: 10 }}>
          <input
            placeholder='e.g. "apical periodontitis antibiotic", "pediatric pulpotomy outcomes"'
            value={q}
            onChange={e => setQ(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && search()}
            style={{ ...inputStyle, flex: 1 }}
          />
          <button onClick={search} disabled={loading} style={{ ...btnStyle, marginTop: 0 }}>
            {loading ? 'Searching…' : 'Search PubMed'}
          </button>
        </div>
      </div>

      {results.length > 0 && (
        <div style={cardStyle}>
          <div style={{ fontSize: 13, marginBottom: 10, color: theme.textMuted }}>
            Showing {results.length} of {total.toLocaleString()} PubMed records
          </div>
          {results.map(r => (
            <div key={r.pmid} style={{ padding: '10px 0', borderBottom: '1px solid #eee' }}>
              <a href={r.url} target="_blank" rel="noreferrer" style={{ fontWeight: 700, color: theme.primary, textDecoration: 'none', fontSize: 14 }}>
                {r.title}
              </a>
              <div style={{ fontSize: 12, color: theme.textMuted, marginTop: 4 }}>
                {r.authors && <span>{r.authors} · </span>}
                <em>{r.journal}</em> · {r.pubDate}
                {r.doi && <> · DOI: <a href={`https://doi.org/${r.doi}`} target="_blank" rel="noreferrer">{r.doi}</a></>}
              </div>
              <div style={{ fontSize: 11, color: theme.textSubtle, marginTop: 2 }}>PMID: {r.pmid}</div>
            </div>
          ))}
        </div>
      )}

      {!loading && results.length === 0 && q && (
        <div style={cardStyle}>
          <p style={{ color: theme.textMuted }}>Run a search to see results.</p>
        </div>
      )}
    </div>
  );
};

export default LiteratureSearchPage;
